<template>
  <div class="bg-dark h-100 py-5 mt-5">
    <div class="container bg-dark">
      <div class="card card-login mx-auto mt-5 p-0" v-if="isFirst">
        <div class="card-header">პაროლის აღდგენა</div>
        <div class="card-body">
          <form>
            <div class="form-group">
              <div class="form-label-group">
                <input
                  type="email"
                  id="inputEmail"
                  class="form-control"
                  placeholder="Email address"
                  autofocus="autofocus"
                  v-model="resetPass.email"
                  v-on:input="$v.resetPass.$touch"
                  v-bind:class="{
                    'error-border': $v.resetPass.email.$error,
                    valid:
                      $v.resetPass.email.$dirty && !$v.resetPass.email.$invalid,
                  }"
                />
                <label for="inputEmail">Email</label>
              </div>
            </div>
            <a
              class="btn btn-primary btn-block mt-5"
              @click="$v.resetPass.$touch(), resetClick()"
              >პაროლის აღდგენა</a
            >
          </form>
        </div>
      </div>
      <div class="card card-login mx-auto mt-5 p-0" v-if="!isFirst">
        <div class="card-header">პაროლის აღდგენა</div>
        <div class="card-body">
          <form>
            <div class="form-group">
              <div class="form-label-group">
                <input
                  type="password"
                  id="inputPassNew"
                  class="form-control"
                  placeholder="Email address"
                  autofocus="autofocus"
                  v-model="resetPassStep2.new"
                  v-on:input="$v.resetPassStep2.$touch"
                  v-bind:class="{
                    'error-border': $v.resetPassStep2.new.$error,
                    valid:
                      $v.resetPassStep2.new.$dirty &&
                      !$v.resetPassStep2.new.$invalid,
                  }"
                />
                <label for="inputPassNew">ახალი პაროლი</label>
                <a
                  href="#"
                  data-toggle="tooltip"
                  title="აუცილებლად მიუთითეთ დიდი და პატარა ასოები და ციფრები. მინიმალური სიგრძე 8"
                  >ინფო</a
                >
              </div>
            </div>
            <div class="form-group">
              <div class="form-label-group">
                <input
                  type="password"
                  id="inputPassNewRe"
                  class="form-control"
                  placeholder="Email address"
                  autofocus="autofocus"
                  v-model="resetPassStep2.newRe"
                  v-on:input="$v.resetPassStep2.$touch"
                  v-bind:class="{
                    'error-border': $v.resetPassStep2.newRe.$error,
                    valid:
                      $v.resetPassStep2.newRe.$dirty &&
                      !$v.resetPassStep2.newRe.$invalid,
                  }"
                />
                <label for="inputPassNewRe">ახალი პაროლი განმეორებით</label>
              </div>
            </div>
            <a
              class="btn btn-primary btn-block mt-5"
              :disabled="!$v.resetPassStep2.$dirty || $v.resetPassStep2.$error"
              @click="$v.resetPassStep2.$touch(), resetStep2Click()"
              >პაროლის შეცვლა</a
            >
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/scss/_login.scss";
import { bus } from "../common/bus";
import { required } from "vuelidate/lib/validators";

export default {
  name: "resetPassword",
  data() {
    return {
      resetPass: {
        email: null,
      },
      resetPassStep2: {
        new: null,
        newRe: null,
      },
      isFirst: true,
    };
  },
  validations: {
    resetPass: {
      email: {
        required,
      },
    },
    resetPassStep2: {
      new: {
        required,
      },
      newRe: {
        required,
      },
    },
  },

  async created() {
    if (this.$route.query.id != undefined) {
      this.isFirst = false;
    }
  },
  methods: {
    async resetClick() {
      //ახლის დამატება

      try {
        let result = await this.$http.resetPassStep1({
          email: this.resetPass.email,
        });

        if (result.data.res === "200") {
          bus.$emit("success", "პაროლის აღდგენის ლინკი გაიგზავნა მეილზე");
        } else {
          bus.$emit("warning", "დაფიქსირდა შეცდომა");
        }
      } catch (error) {
        console.log(error);
        bus.$emit("error", error);
      }
    },
    async resetStep2Click() {
      if (this.resetPassStep2.new != this.resetPassStep2.newRe) {
        bus.$emit("warning", "პაროლები არ ემთხვევა ერთმანეთს");
        return;
      }

      try {
        let result = await this.$http.resetPassStep2({
          guid: this.$route.query.id,
          new: this.resetPassStep2.new,
          newRe: this.resetPassStep2.newRe,
        });

        if (result.data.res === "200") {
          bus.$emit("success", "პაროლი წარმატებით შეიცვალა");

          this.$router.push("/");
        } else {
          bus.$emit("warning", "დაფიქსირდა შეცდომა");
        }
      } catch (error) {
        console.log(error);
        bus.$emit("error", error);
      }
    },
    clearData() {},
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";

.error-border {
  border-color: #ffb3b3;
  box-shadow: none;
}
.editBtn {
  margin-left: 10px;
  font-size: 30px;
  cursor: pointer;
  color: #52af8e;
}
.deleteBtn {
  font-size: 30px;
  cursor: pointer;
  color: #d43f3a;
  margin-left: 10px;
}

.searchBtn {
  font-size: 40px;
  margin-top: -5px;
  cursor: pointer;
  color: #489d7f;
}

.addNewBtn {
  font-size: 44px;
  margin-left: 15px;
  cursor: pointer;
  color: #52af8e;
  margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/ResetPassword.vue